import { Component } from "@angular/core";
import { SharedDataService } from "../../services/shared-data.service";
import { DatePipe } from "@angular/common";
import { PaymentIntentsService } from "../../services/graphQl/payment-intents/payment-intents.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { NormalizeDataService } from "../../services/normalize-data.service";
import { environment } from "../../../environments/environment";
import { take } from "rxjs/operators";
import { createEmbeddingContext, EmbeddingContext } from "amazon-quicksight-embedding-sdk";
import * as QuicksightEmbedding from "amazon-quicksight-embedding-sdk";
import { AuthService } from "../../services/auth.service";

const { quickSightBaseUrl, quickSightDashboards } = environment;
type DashboardPanel = "sales" | "conciliations";

@Component({
  selector: "app-conciliations-general",
  standalone: true,
  imports: [],
  templateUrl: "./conciliations-general.component.html",
  styleUrl: "./conciliations-general.component.css",
})
export class ConciliationsGeneralV2Component {
  formattedCreatedAtFrom: string = "";
  formattedcreatedAtTo: string = "";
  embeddingContext: EmbeddingContext;
  private dashboardUrls: Record<DashboardPanel, string> = {
    sales: "",
    conciliations: "",
  };
  private dashboards: Record<DashboardPanel, QuicksightEmbedding.DashboardExperience> = {
    sales: null,
    conciliations: null,
  };

  constructor(
    public sharedDataService: SharedDataService,
    private datePipe: DatePipe,
    private paymentIntentsService: PaymentIntentsService,
    private http: HttpClient,
    private router: Router,
    public normalizeDataService: NormalizeDataService,
  ) {
    this.formattedCreatedAtFrom = this.datePipe.transform(localStorage.getItem("calendar.created_at_from"), "dd-MM-yyyy");
    this.formattedcreatedAtTo = this.datePipe.transform(localStorage.getItem("calendar.created_at_to"), "dd-MM-yyyy");
  }

  ngOnInit(): void {
    this.updateDate();
    this.GetDashboardURL();
    // this.makeQueryPaymentIntent();
  }

  updateDate() {
    const createdAtFrom = new Date(localStorage.getItem("calendar.created_at_from"));
    const createdAtTo = new Date(localStorage.getItem("calendar.created_at_to"));

    // Suma un día a las fechas
    createdAtFrom.setDate(createdAtFrom.getDate() + 1);
    // createdAtTo.setDate(createdAtTo.getDate() + 1);

    // Formatear las fechas en el formato ('dd-MM-yyyy')
    this.formattedCreatedAtFrom = this.datePipe.transform(createdAtFrom, "dd-MM-yyyy");
    this.formattedcreatedAtTo = this.datePipe.transform(createdAtTo, "dd-MM-yyyy");
  }

  public GetDashboardURL() {
    const createdAtFrom = this.formattedCreatedAtFrom.substring(6, 10) + "-" + this.formattedCreatedAtFrom.substring(3, 5) + "-" + this.formattedCreatedAtFrom.substring(0, 2);
    const createdAtTo = this.formattedcreatedAtTo.substring(6, 10) + "-" + this.formattedcreatedAtTo.substring(3, 5) + "-" + this.formattedcreatedAtTo.substring(0, 2);
    const merchantId = localStorage.getItem("auth.merchant_id");
    const paramsUrl = "#p.merchantId=" + merchantId + "&p.createdAtFrom=" + createdAtFrom + "&p.createdAtTo=" + createdAtTo;
    console.log("createdAtFrom", createdAtFrom);
    console.log("createdAtTo", createdAtTo);

    this.loadDashboardPanel("sales", quickSightDashboards.conciliations_general_v2, "dashboardSalesContainer", paramsUrl, merchantId, createdAtFrom, createdAtTo);
    this.loadDashboardPanel("conciliations", quickSightDashboards.conciliations_dashboard, "dashboardConciliationsContainer", paramsUrl, merchantId, createdAtFrom, createdAtTo);
  }

  private loadDashboardPanel(panel: DashboardPanel, dashboardId: string, containerId: string, paramsUrl: string, merchantId: string, createdAtFrom: string, createdAtTo: string) {
    const cachedUrl = this.dashboardUrls[panel];
    if (cachedUrl) {
      this.Dashboard(cachedUrl + paramsUrl, containerId, panel, merchantId, createdAtFrom, createdAtTo);
      return;
    }

    const authToken = localStorage.getItem("auth.access_token");
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }),
    };

    this.http
      .get(`${quickSightBaseUrl}/${dashboardId}`, httpOptions)
      .pipe(take(1))
      .subscribe((data: any) => {
        this.dashboardUrls[panel] = data.EmbedUrl;
        const urlWithParams = data.EmbedUrl + paramsUrl;
        this.Dashboard(urlWithParams, containerId, panel, merchantId, createdAtFrom, createdAtTo);
      });
  }

  public async Dashboard(embeddedURL: string, containerId: string, panel: DashboardPanel, merchantId: string, createdAtFrom: string, createdAtTo: string) {
    var containerDiv = document.getElementById(containerId) || "";
    const frameOptions = {
      url: embeddedURL,
      container: containerDiv,
      height: "800px",
      width: "100%",
      resizeHeightOnSizeChangedEvent: true,
    };
    if (!this.embeddingContext) {
      this.embeddingContext = await createEmbeddingContext();
    }
    if (this.dashboards[panel] == null) {
      this.dashboards[panel] = await this.embeddingContext.embedDashboard(frameOptions);
      console.log("Dashboard", this.dashboards[panel]);
    } else {
      this.dashboards[panel].setParameters([
        {
          Name: "merchantId",
          Values: [merchantId],
        },
        {
          Name: "createdAtFrom",
          Values: [createdAtFrom],
        },
        {
          Name: "createdAtTo",
          Values: [createdAtTo],
        },
      ]);
    }
  }
}
